import { render, staticRenderFns } from "./AddNewComplexRole.vue?vue&type=template&id=37c4f564&scoped=true"
import script from "./AddNewComplexRole.vue?vue&type=script&lang=js"
export * from "./AddNewComplexRole.vue?vue&type=script&lang=js"
import style0 from "./AddNewComplexRole.vue?vue&type=style&index=0&id=37c4f564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c4f564",
  null
  
)

export default component.exports